<script>
let location = window.location.href;

let validate =
  location.indexOf("://cardiff") > -1 || location.indexOf("www.cardiff") > -1;
console.log("location", location, validate);
// validate = true;
export default {
  name: "ApplyPage",
  data() {
    return {
      validate: validate,
    };
  },
  methods: {
    next() {
      var foundErrors = false;
      this.$children.forEach((child) => {
        if (typeof child.validate === "function") {
          if (!child.validate()) {
            console.log("error", child.inputName);
            foundErrors = true;
          }
        }
      });
      console.log(this.$data);
      if (foundErrors && this.validate) {
        console.log("errors found", this.validate);

        //focus on the error
        setTimeout(function () {
          let domRect = document
            .querySelector(".is-danger:first-child")
            .getBoundingClientRect();
          window.scrollTo(
            domRect.left + document.documentElement.scrollLeft - 70,
            domRect.top + document.documentElement.scrollTop - 70
          );
          console.log("returning error:");
        }, 500);

        return;
      }

      this.$emit("next", this.$data);
    },
    validateInPlace() {
      var foundErrors = false;
      this.$children.forEach((child) => {
        if (typeof child.validate === "function") {
          if (!child.validate()) {
            console.log("error", child.inputName);
            foundErrors = true;
          }
        }
      });
      console.log(this.$data);
      if (foundErrors) {
        console.log("errors found", this.validate);
        return false;
      }
      return true;
    },
    back() {
      this.$emit("back");
    },
    updateAddress(obj) {
      this.$refs.city.setValue(obj.city);
      this.$refs.state.setValue(obj.state);
      this.$refs.zip.setValue(obj.zip);
    },
  },
};
</script>
